import { render, staticRenderFns } from "./DataTableforReport.vue?vue&type=template&id=76a48c33&"
import script from "./DataTableforReport.vue?vue&type=script&lang=js&"
export * from "./DataTableforReport.vue?vue&type=script&lang=js&"
import style0 from "./DataTableforReport.vue?vue&type=style&index=0&id=76a48c33&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports